// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter[data-v-27c5ee70]{opacity:0}.fade-enter-active[data-v-27c5ee70]{transition:opacity 1s ease-in-out}.fade-enter-to[data-v-27c5ee70]{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
